module.exports = __webpack_public_path__ + "img/ThroneRoom.6b6f5bff.png";